import { mapDrawerNarrativeContent, type DrawerNarrativeContent } from "./drawer-narrative-content"
import type { MyBrandConcept, ParsedMyBrandDrawerData } from "./parse-my-brand-drawer-data"

export type MyBrandDrawerNarrativeContent = Omit<DrawerNarrativeContent, "concepts"> & {
  concepts: MyBrandConcept[]
}

export function mapMyBrandDrawerNarrative(
  parsed: ParsedMyBrandDrawerData | null,
  emptyValue: string,
): MyBrandDrawerNarrativeContent {
  const base = mapDrawerNarrativeContent(
    parsed ? { ...parsed, concepts: [] } : null,
    emptyValue,
  )
  return {
    ...base,
    concepts: parsed?.concepts ?? [],
  }
}
